/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';

/**
 * 
 * @export
 * @interface PaymentMethodCountryConnectionDto
 */
export interface PaymentMethodCountryConnectionDto {
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {CountryCode}
     * @memberof PaymentMethodCountryConnectionDto
     */
    countryCode: CountryCode;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    createdByUserEmail: string;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof PaymentMethodCountryConnectionDto
     */
    defaultEnabledInApps: Set<FavritApp>;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    externalId: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCountryConnectionDto
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodCountryConnectionDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCountryConnectionDto
     */
    paymentsEnabled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    updatedByUserEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    activeTo?: Date | null;
}



/**
 * Check if a given object implements the PaymentMethodCountryConnectionDto interface.
 */
export function instanceOfPaymentMethodCountryConnectionDto(value: object): value is PaymentMethodCountryConnectionDto {
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('createdByUserEmail' in value) || value['createdByUserEmail'] === undefined) return false;
    if (!('defaultEnabledInApps' in value) || value['defaultEnabledInApps'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentsEnabled' in value) || value['paymentsEnabled'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('updatedByUserEmail' in value) || value['updatedByUserEmail'] === undefined) return false;
    return true;
}

export function PaymentMethodCountryConnectionDtoFromJSON(json: any): PaymentMethodCountryConnectionDto {
    return PaymentMethodCountryConnectionDtoFromJSONTyped(json, false);
}

export function PaymentMethodCountryConnectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodCountryConnectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'activeFrom': (new Date(json['activeFrom'])),
        'countryCode': CountryCodeFromJSON(json['countryCode']),
        'created': (new Date(json['created'])),
        'createdByUserEmail': json['createdByUserEmail'],
        'defaultEnabledInApps': (new Set((json['defaultEnabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'externalId': json['externalId'],
        'isActive': json['isActive'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentsEnabled': json['paymentsEnabled'],
        'updated': (new Date(json['updated'])),
        'updatedByUserEmail': json['updatedByUserEmail'],
        'activeTo': json['activeTo'] === undefined ? undefined : json['activeTo'] === null ? null : (new Date(json['activeTo'])),
    };
}

export function PaymentMethodCountryConnectionDtoToJSON(json: any): PaymentMethodCountryConnectionDto {
    return PaymentMethodCountryConnectionDtoToJSONTyped(json, false);
}

export function PaymentMethodCountryConnectionDtoToJSONTyped(value?: PaymentMethodCountryConnectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeFrom': value['activeFrom'].toISOString(),
        'countryCode': CountryCodeToJSON(value['countryCode']),
        'created': value['created'].toISOString(),
        'createdByUserEmail': value['createdByUserEmail'],
        'defaultEnabledInApps': (Array.from(value['defaultEnabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'externalId': value['externalId'],
        'isActive': value['isActive'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentsEnabled': value['paymentsEnabled'],
        'updated': value['updated'].toISOString(),
        'updatedByUserEmail': value['updatedByUserEmail'],
        'activeTo': value['activeTo'] == null ? value['activeTo'] : value['activeTo'].toISOString(),
    };
}

